/**
 * Topbar component with user menu and search.
 */

import { useAuth } from '@/hooks/useAuth';
import { useMe } from '@/hooks/useAuth';
import { useState } from 'react';
import { Search, User, LogOut } from 'lucide-react';
import './topbar.scss';

export function Topbar() {
  const { user, signOut } = useAuth();
  const { data: me } = useMe();
  const [showMenu, setShowMenu] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    setShowMenu(false);
  };

  return (
    <div className="topbar">
      <div className="topbar__search">
        <div className="topbar__search-container">
          <Search className="topbar__search-icon" />
          <input
            type="text"
            placeholder="Search placements, domains..."
            className="topbar__search-input"
          />
        </div>
      </div>
      <div className="topbar__user">
        <button
          onClick={() => setShowMenu(!showMenu)}
          className="topbar__user-button"
        >
          <div className="topbar__user-avatar">
            <User />
          </div>
          <div className="topbar__user-info">
            <p className="topbar__user-info-name">{user?.email}</p>
            <p className="topbar__user-info-org">{me?.org.name}</p>
          </div>
        </button>
        {showMenu && (
          <div className="topbar__user-menu">
            <div className="topbar__user-menu-section">
              <div className="topbar__user-menu-info">
                <p className="topbar__user-menu-info-name">{user?.email}</p>
                <p className="topbar__user-menu-info-org">{me?.org.name}</p>
              </div>
              <button
                onClick={handleSignOut}
                className="topbar__user-menu-item"
              >
                <LogOut />
                Sign out
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

